<div class="layout">
    <header>
        @if (pfSegData.segmentId()) {
            <div class="save-and-cancel-box layout-hbox" style="gap: 5px; border-right: 2px black">
                <fluent-button class="small-height" appearance="primary" (click)="saveSegment()"
                               [disabled]="isSaveDisabled()"><i class="fat fa-save"></i> Save
                </fluent-button>
                <fluent-button class="small-height cancel-button" (click)="pfSegData.discard()" [disabled]="!pfSegData.isDirty()"><i class="fat fa-xmark-octagon"></i> Discard</fluent-button>
            </div>
        }
        @if (pfData.portfolioId()) {
            <i class="fat fa-ellipsis-v"></i>
            <span style="font-weight: bold">{{breadcrumbs()}}</span>
            <fluent-badge style="background-color: var(--site-success-color2)">{{pfSegData.segmentStatus()}}</fluent-badge>

            <i class="fat fa-pipe"></i>
            <i class="fat fa-filter app-period-filter-label"></i>

            <div class="period-toggle-buttons">
                <fluent-toggle-button [attr.pressed]="isPeriodActive(PortfolioPeriodEnum.Hy)" (click)="togglePeriod(PortfolioPeriodEnum.Hy)">HY</fluent-toggle-button>
                <fluent-toggle-button [attr.pressed]="isPeriodActive(PortfolioPeriodEnum.Q3)" (click)="togglePeriod(PortfolioPeriodEnum.Q3)">Q3</fluent-toggle-button>
                <fluent-toggle-button [attr.pressed]="isPeriodActive(PortfolioPeriodEnum.Q4)" (click)="togglePeriod(PortfolioPeriodEnum.Q4)">Q4</fluent-toggle-button>
            </div>
        }

        <span style="flex: 1"></span>

        @if (pfSegData.accountDataFormulaEvaluation.isLoading()) {
            <i class="far fa-spin fa-spinner"></i>
        } @else if (pfSegData.accountDataFormulaEvaluation.error()) {
            <i class="far fa-exclamation-triangle" style="color: red" title="{{pfSegData.accountDataFormulaEvaluation.error()}}"></i>
        }

        <fluent-button class="tiny-height" appearance="outline" (click)="onRecalculate()" [disabled]="!isCtxPfActive()" title="Recalculate">
            <i class="far fa-calculator"></i>
        </fluent-button>
        <fluent-button class="tiny-height" appearance="outline" (click)="onExitPortfolio()" [disabled]="!isCtxPfActive()" title="Exit Portfolio">
            <i class="far fa-portal-exit"></i>
        </fluent-button>
        <fluent-button class="tiny-height" appearance="outline">
            <i class="far fa-question-circle"></i>
        </fluent-button>
    </header>

    <app-nav-bar>
        <app-navigation-link text="Portfolios" link="/app/archive" icon="fa-archive"></app-navigation-link>

        <app-navigation-link text="Planning" icon="fa-compass" [disabled]="!isCtxPfActive()" [isExpanded]="false">
            <app-navigation-link-subitem text="PLR / NLR" [link]="segmentLink('/config/lrdata')" icon="fa-chart-line"></app-navigation-link-subitem>
            <app-navigation-link-subitem text="KPIs" [link]="segmentLink('/config/kpis')" icon="fa-tachometer-alt"></app-navigation-link-subitem>
            <app-navigation-link-subitem text="XRates" [link]="segmentLink('/config/fxrates')" icon="fa-chart-line"></app-navigation-link-subitem>
        </app-navigation-link>

        <app-navigation-link text="LoBs & Offices" [link]="portfolioLink('/members')" icon="fa-buildings" [disabled]="!isCtxPfActive()">
        </app-navigation-link>

        <app-navigation-link text="Overview" [link]="segmentLink('overview')" icon="fa-chart-pie-simple"
                             [disabled]="!isCtxMemberActive()"></app-navigation-link>

        <app-navigation-link text="Account Data" [link]="segmentLink('accounts')" icon="fa-list"
                             [disabled]="!isCtxMemberActive()"></app-navigation-link>

        <app-navigation-link text="Checks" [link]="segmentLink('checks')" icon="fa-info-circle" [disabled]="!isCtxMemberActive()"></app-navigation-link>

        <app-navigation-link text="Status" [link]="segmentLink('status')" icon="fa-traffic-light" [disabled]="!isCtxMemberActive()"></app-navigation-link>

        <app-navigation-link text="Dashboards" icon="fa-chart-line-up" [isExpanded]="true" [disabled]="!isCtxMemberActive()">
            <app-navigation-link-subitem text="Targets" [link]="segmentLink('/dashboard/targets')" icon="fa-bullseye-arrow"></app-navigation-link-subitem>
            <app-navigation-link-subitem text="Tracking" [link]="segmentLink('/dashboard/tracking')" icon="fa-chart-pie"></app-navigation-link-subitem>
            <app-navigation-link-subitem text="Volatility"
                                         appAccessControl="lob.PRP" acAction="hide"
                                         [link]="segmentLink('/dashboard/volatility')" icon="fa-chart-line-up-down">
            </app-navigation-link-subitem>
        </app-navigation-link>

        <app-navigation-link text="PF Reports" icon="fa-file-contract" [isExpanded]="true" [disabled]="!isCtxMemberActive()">
            <app-navigation-link-subitem text="Targets" [link]="segmentLink('/report/targets')" icon="fa-bullseye-arrow"></app-navigation-link-subitem>
            <app-navigation-link-subitem text="Tracking" [link]="segmentLink('/report/tracking')"  icon="fa-chart-pie"></app-navigation-link-subitem>
            <!--
            <app-navigation-link-subitem text="UW status" [link]="segmentLink('/xrep/uwstatus')"  icon="fa-chart-pie"></app-navigation-link-subitem>
            <app-navigation-link-subitem text="UW Strategy" [link]="segmentLink('/xrep/uwstrategy')"  icon="fa-chart-pie"></app-navigation-link-subitem>
            -->
        </app-navigation-link>

        @if (devToolsSvc.isDevMode()) {
            <app-navigation-link text="Dev Tools" [link]="segmentLink('/devtools')" icon="fa-tools"></app-navigation-link>
        }

        <app-navigation-link text="Users" [link]="portfolioLink('/appusers')" icon="fa-users"
                             appAccessControl="role.devops" acAction="hide"
        ></app-navigation-link>

        <div style="flex: 1">&nbsp;</div>
        <div class="menu-divider"></div>
        <div class="layout-vbox">
            <div class="app-user-name" (click)="onShowUserDetails()">{{authService.appUser()?.name}}</div>
            @if(!authService.isAuthenticated()) {
                <app-navigation-link text="Login" icon="fa fa-door-open" (click)="onUserLogin()"></app-navigation-link>
            } @else {
                <app-navigation-link text="Logout" icon="fa fa-door-closed" (click)="onUserLogout()"></app-navigation-link>
            }
        </div>
    </app-nav-bar>
    <main>
        <router-outlet></router-outlet>
    </main>
    <footer>
        <div style="position: absolute; left: 10px;">Left</div>
        <div>
            Portfolio Management Platform {{AppVersion.tags || AppVersion.version}} &middot;
            &copy;2025-2026 &middot; GC&C &middot;
            Rev {{ AppVersion.revision }} &middot;
            {{ AppVersion.commitedAt | date: 'dd.MM.yyyy HH:mm' }} &middot;
            <i class="far fa-code-branch"></i> {{ AppVersion.branch }} &middot;
            @if (ApiConfiguration.envApiPy()) {
                <fluent-badge appearance="primary">py: {{ApiConfiguration.envApiPy()}}</fluent-badge>
            }
            @if (ApiConfiguration.envApiKt()) {
                <fluent-badge appearance="primary">kt: {{ApiConfiguration.envApiKt()}}</fluent-badge>
            }
            <fluent-badge #roleBadge appearance="primary" [style.display]="devToolsRoleBadgeDisplay()" (click)="onShowDevToolsRolePermissions()"
                          style="cursor: help">
                App Role
            </fluent-badge>
        </div>
        <div class="grid-selection-summary" (click)="onCopySelectedValueToClipboard()">
            <b>Num:</b> {{selectedRangeSummary().numNumeric | wijmoFormat: 'n0'}},
            <b>Avg:</b> {{selectedRangeSummary().avgNumeric | wijmoFormat: 'n5'}},
            <b>Sum:</b> {{selectedRangeSummary().sumNumeric | wijmoFormat: 'n5'}}
        </div>
    </footer>
</div>
